// extracted by mini-css-extract-plugin
export default {"container":"AboutMe_container__qQaMs","image":"AboutMe_image__6tuK0","content":"AboutMe_content__7X58U","text":"AboutMe_text__Oj4M5","footer":"AboutMe_footer__5RQjq"};